/** Open security alerts as rows in Overview's "Needs you", in the shape its rows already use. */
import { ShieldAlert, ShieldX } from '@orgus/ui/icons';
import { useMemo } from 'react';
import type { ComponentType } from 'react';
import { useOrgus } from '../../lib/store.ts';
import { securityNeeds } from './model.ts';
import type { SecurityNeedItem, SecurityNeedKind } from './model.ts';
import { useSecurity } from './useSecurity.ts';

export type { SecurityNeedItem, SecurityNeedKind };

export const SECURITY_NEED_KIND: Record<SecurityNeedKind, { icon: ComponentType<{ className?: string }>; cls: string; label: string }> = {
  securityCritical: { icon: ShieldX, cls: 'text-failed bg-failed-soft', label: 'Security alert, critical' },
  securityWarning: { icon: ShieldAlert, cls: 'text-waiting bg-waiting-soft', label: 'Security alert' },
};

export function useSecurityNeedItems(): SecurityNeedItem[] {
  const { state } = useSecurity();
  const machines = useOrgus((s) => s.machines);
  return useMemo(() => (state ? securityNeeds(state.alerts, machines) : []), [state, machines]);
}
